var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
function IconProductsUnselectedComponent(props, ref) {
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    _b = props.prefix,
    prefix = _b === void 0 ? 'arco' : _b,
    _c = props.width,
    width = _c === void 0 ? '1em' : _c,
    _d = props.height,
    height = _d === void 0 ? '1em' : _d,
    _e = props.useCurrentColor,
    useCurrentColor = _e === void 0 ? true : _e,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: prefix + "-icon " + prefix + "-icon-Products_unselected " + className,
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.494 2h-.457l-.041.455-1 11-.05.545h12.095l-.05-.545-1-11-.04-.455H3.493zM3.04 13l.91-10h8.086l.91 10H3.04zm4.953-5.5a1.96 1.96 0 01-1.96-1.96h-1a2.96 2.96 0 005.919 0h-1a1.96 1.96 0 01-1.96 1.96z"
  }));
}
var IconProductsUnselected = /*#__PURE__*/React.forwardRef(IconProductsUnselectedComponent);
export default IconProductsUnselected;